import NoteIcon from '@assets/icons/note.svg';
import React from 'react';
import SendNoteIcon from '@assets/icons/send-note.svg';
import { createStyles } from '@/contexts/theme-context';
import { TouchableOpacity, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface MemoRowProps {
  children: React.ReactNode;
  onPress: () => void;
}

export const MemoRow: React.FC<MemoRowProps> = ({ children, onPress }) => {
  const [styles, theme] = useStyles();

  return (
    <TouchableOpacity
      accessibilityRole="button"
      focusable={false}
      onPress={onPress}
      style={styles.memoContainer}
    >
      <NoteIcon
        height={16}
        stroke={theme.sk.color.icon.secondary}
        style={styles.icon}
        width={16}
      />
      <Typography flexShrink={1} numberOfLines={1} variant="paragraph-sm">
        {children}
      </Typography>
    </TouchableOpacity>
  );
};

interface RequestButtonProps {
  accessibilityLabel?: string;
  onPress: () => void;
}

export const RequestButton: React.FC<RequestButtonProps> = ({
  accessibilityLabel,
  onPress,
}) => {
  const [styles, theme] = useStyles();

  return (
    <TouchableOpacity
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      focusable={false}
      onPress={onPress}
      style={styles.requestContainer}
    >
      <SendNoteIcon
        height={16}
        stroke={theme.sk.color.icon.secondary}
        width={16}
      />
    </TouchableOpacity>
  );
};

interface NoteContainerProps {
  children: React.ReactNode;
}

export const NoteContainer: React.FC<NoteContainerProps> = ({ children }) => {
  const [styles] = useStyles();

  return <View style={styles.container}>{children}</View>;
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
    justifyContent: 'flex-end',
  },
  icon: {
    flexShrink: 0,
  },
  memoContainer: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.highlight.tertiary,
    borderRadius: theme.sk.radii.radiusSmall,
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceXsmall,
    padding: theme.sk.spacing.spaceSmall,
  },
  requestContainer: {
    backgroundColor: theme.sk.color.bg.dsr,
    borderRadius: theme.sk.radii.radiusSmall,
    padding: theme.sk.spacing.spaceSmall,
  },
}));
